import { useState } from 'react';
import useDeviceType from 'lib/hooks/useDeviceType';

type IngredientSelectorProps = {
  isSelected: boolean;
};

const IngredientSelector: React.FC<IngredientSelectorProps> = ({
  isSelected,
}) => {
  const deviceType = useDeviceType();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    if (
      deviceType.deviceType !== 'phone' &&
      deviceType.deviceType !== 'tablet'
    ) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (
      deviceType.deviceType !== 'phone' &&
      deviceType.deviceType !== 'tablet'
    ) {
      setIsHovered(false);
    }
  };

  const handleTouchStart = () => {
    if (
      deviceType.deviceType === 'phone' ||
      deviceType.deviceType === 'tablet'
    ) {
      setIsHovered(false);
    }
  };

  const handleTouchEnd = () => {
    if (
      deviceType.deviceType === 'phone' ||
      deviceType.deviceType === 'tablet'
    ) {
      setIsHovered(false);
    }
  };

  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {isHovered ? (
        <>
          <rect
            x="1.59186"
            y="1.66992"
            width="18.5"
            height="18.5"
            rx="9.25"
            stroke="#1f1f1f"
            strokeWidth="1.5"
          />
          <path
            d="M5.68986 11.8089C5.65044 11.7695 5.61916 11.7228 5.59782 11.6713C5.57648 11.6198 5.56549 11.5646 5.56549 11.5089C5.56549 11.4532 5.57648 11.398 5.59782 11.3465C5.61916 11.2951 5.65044 11.2483 5.68986 11.2089L6.74486 10.1569C6.78411 10.1173 6.83083 10.0858 6.88232 10.0643C6.93382 10.0428 6.98906 10.0317 7.04486 10.0317C7.10066 10.0317 7.15591 10.0428 7.2074 10.0643C7.2589 10.0858 7.30562 10.1173 7.34486 10.1569L9.05486 11.8659C9.09418 11.9055 9.14092 11.9369 9.1924 11.9583C9.24389 11.9797 9.2991 11.9907 9.35486 11.9907C9.41063 11.9907 9.46584 11.9797 9.51732 11.9583C9.56881 11.9369 9.61555 11.9055 9.65486 11.8659L14.3439 7.16092C14.3832 7.12138 14.4299 7.08999 14.4814 7.06857C14.5329 7.04716 14.5881 7.03613 14.6439 7.03613C14.6996 7.03613 14.7548 7.04716 14.8063 7.06857C14.8578 7.08999 14.9046 7.12138 14.9439 7.16092L15.9929 8.20292C16.0325 8.24217 16.064 8.28889 16.0855 8.34038C16.107 8.39188 16.1181 8.44712 16.1181 8.50292C16.1181 8.55872 16.107 8.61397 16.0855 8.66546C16.064 8.71696 16.0325 8.76368 15.9929 8.80292L10.3009 14.5029C10.102 14.682 9.84802 14.7878 9.58086 14.8029H9.08886C8.82193 14.7882 8.56813 14.6823 8.36986 14.5029L5.68986 11.8089Z"
            fill="#1f1f1f"
          />
        </>
      ) : (
        <>
          <rect
            x="1.59186"
            y="1.66992"
            width="18.5"
            height="18.5"
            rx="9.25"
            stroke="#97928F"
            strokeWidth="1.5"
          />
        </>
      )}
      {isSelected && (
        <>
          <rect width="21" height="21" />
          <g id="RCE94-95">
            <path d="M-774 -897.772C-774 -898.877 -773.105 -899.772 -772 -899.772H138C139.105 -899.772 140 -898.877 140 -897.772V332.228C140 333.332 139.105 334.228 138 334.228H-772C-773.105 334.228 -774 333.332 -774 332.228V-897.772Z" />
            <path
              d="M-772 -898.772H138V-900.772H-772V-898.772ZM139 -897.772V332.228H141V-897.772H139ZM138 333.228H-772V335.228H138V333.228ZM-773 332.228V-897.772H-775V332.228H-773ZM-772 333.228C-772.552 333.228 -773 332.78 -773 332.228H-775C-775 333.884 -773.657 335.228 -772 335.228V333.228ZM139 332.228C139 332.78 138.552 333.228 138 333.228V335.228C139.657 335.228 141 333.884 141 332.228H139ZM138 -898.772C138.552 -898.772 139 -898.325 139 -897.772H141C141 -899.429 139.657 -900.772 138 -900.772V-898.772ZM-772 -900.772C-773.657 -900.772 -775 -899.429 -775 -897.772H-773C-773 -898.325 -772.552 -898.772 -772 -898.772V-900.772Z"
              fill="black"
              fillOpacity="0.1"
            />
            <g id="Ingredients-Selected">
              <path
                id="Ellipse 269"
                d="M10.8419 20.9199C16.3647 20.9199 20.8419 16.4428 20.8419 10.9199C20.8419 5.39707 16.3647 0.919922 10.8419 0.919922C5.31901 0.919922 0.841858 5.39707 0.841858 10.9199C0.841858 16.4428 5.31901 20.9199 10.8419 20.9199Z"
                fill="#D73A15"
              />
              <path
                id="Fill 2"
                d="M5.96483 11.6917C5.9254 11.6524 5.89412 11.6056 5.87278 11.5541C5.85144 11.5026 5.84045 11.4475 5.84045 11.3917C5.84045 11.336 5.85144 11.2808 5.87278 11.2294C5.89412 11.1779 5.9254 11.1311 5.96483 11.0917L7.01983 10.0397C7.05907 10.0001 7.10579 9.96858 7.15729 9.94708C7.20878 9.92559 7.26403 9.91453 7.31983 9.91453C7.37563 9.91453 7.43087 9.92559 7.48237 9.94708C7.53386 9.96858 7.58058 10.0001 7.61983 10.0397L9.32983 11.7487C9.36914 11.7883 9.41588 11.8197 9.46737 11.8411C9.51885 11.8625 9.57407 11.8735 9.62983 11.8735C9.68559 11.8735 9.7408 11.8625 9.79229 11.8411C9.84377 11.8197 9.89052 11.7883 9.92983 11.7487L14.6188 7.04374C14.6581 7.00419 14.7049 6.9728 14.7564 6.95139C14.8079 6.92997 14.8631 6.91895 14.9188 6.91895C14.9746 6.91895 15.0298 6.92997 15.0813 6.95139C15.1328 6.9728 15.1795 7.00419 15.2188 7.04374L16.2678 8.08574C16.3075 8.12498 16.339 8.1717 16.3605 8.2232C16.382 8.27469 16.393 8.32994 16.393 8.38574C16.393 8.44154 16.382 8.49678 16.3605 8.54828C16.339 8.59977 16.3075 8.64649 16.2678 8.68574L10.5758 14.3857C10.377 14.5648 10.123 14.6706 9.85583 14.6857H9.36383C9.09689 14.671 8.8431 14.5651 8.64483 14.3857L5.96483 11.6917Z"
                fill="white"
              />
            </g>
          </g>
        </>
      )}
    </svg>
  );
};

export default IngredientSelector;
